import React, { useRef } from 'react';
import Content from '@component/common/content';
import Scroll from '@component/common/scroll';
import Landing from '@component/gridgio/landing';

const LandingPage: React.FC = () => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  return (
    <Content top='0px' bottom='0px'>
      <Scroll direction='y' height='100%' containerRef={scrollContainerRef}>
        <Landing scrollContainerRef={scrollContainerRef} />
      </Scroll>
    </Content>
  );
};

export default LandingPage;
